/**
 * DEV-1083. Переводы импорт-визарда прайсов и черновиков импорта.
 *
 * Отдельным модулем, как propertyForm/propertyUnits: правки визарда не конфликтуют с общим
 * ru.ts, который правят все подряд.
 */

const ruImport = {
  title: 'Импорт прайса застройщика',
  steps: {
    upload: 'Загрузка файла',
    preview: 'Превью и правки',
    apply: 'Применение',
  },
  dropzone: 'Перетащите файл прайса или нажмите для выбора',
  dropzoneHint: 'XLSX или CSV, до {size} МБ. Разбираются все вкладки, включая скрытые.',
  noDriveLinks:
    'Ссылки на Google Drive не поддерживаются — откройте таблицу и скачайте: Файл → Скачать → Microsoft Excel (.xlsx).',
  chooseAnother: 'Выбрать другой файл',
  tooLarge: 'Файл больше {size} МБ',
  badFormat: 'Поддерживаются xlsx, xlsm, csv, tsv и txt',
  parseAction: 'Загрузить и разобрать',
  parsing: 'Разбираем файл…',
  parsingHint: 'Прайс на сотни строк занимает до минуты — страницу можно не закрывать.',
  parseFailed: 'Не удалось разобрать файл',
  noRows: 'В файле не нашлось строк, похожих на юниты — попробуйте другую вкладку',
  noRowsWithCode: 'Ни в одной строке нет кода юнита — импортировать нечего',
  rowsParsed: 'Строк: {count}',
  facts: {
    sheet: 'Вкладка',
    skippedEmpty: 'Пустых строк',
    skippedNoise: 'Не похожи на юнит',
    unmapped: 'Колонок не узнано',
  },
  unmappedHint: 'Не узнаны колонки: {columns}. Их значения в каталог не попадут.',
  // Заметки разбора приходят из харвестера кодом и параметрами (DEV-1838):
  // раньше это была готовая русская фраза, и на en/vn она такой и оставалась.
  notes: {
    priceUnitsAssumed:
      'В колонке цены не указаны единицы: значения меньше 1000 прочитаны как tỷ (млрд ₫).',
    objectTypeColumnMissing:
      'Колонка типа объекта в файле не найдена: без типа юниты не попадут в витрину сайта — проставьте его ниже.',
    objectTypeUnrecognized:
      'Тип объекта не распознан в {rows} строках из {total}: без типа юнит не попадёт в витрину сайта.',
    sheetNotFound: 'Вкладки «{sheet}» нет в файле — разобрана лучшая по содержимому.',
    unitsTableNotFound: 'Таблица юнитов не найдена: нет вкладки с распознанными заголовками.',
    headerRowNotFound: 'На вкладке «{sheet}» не найдена строка заголовков.',
    sheetHidden: 'Вкладка «{sheet}» скрыта в файле — каталог взят с неё.',
    areaAmbiguous:
      'Площадь из колонки «{header}» отнесена к tim tường (built-up): в заголовке вид площади не указан.',
    rowsNotRecognized: 'Строки юнитов не распознаны — проверьте выбранную вкладку.',
  },
  sheet: 'Вкладка',
  sheetOption: '{name} · строк: {rows}',
  sheetHidden: '{name} (скрытая) · строк: {rows}',
  reparse: 'Перечитать',
  targetProject: 'Целевой проект',
  targetExisting: 'Добавить в существующий',
  targetNew: 'Создать новый проект — будет заведён как черновик (не публикуется)',
  targetNewHint:
    'Черновик импорта создастся без проекта: привяжете его на следующем шаге, когда заведёте проект.',
  searchProject: 'Начните вводить название проекта',
  createDraft: 'Создать черновик',
  createDraftError: 'Не удалось создать черновик импорта',
  skippedNoCode: 'Пропущено строк без кода юнита: {count}',
  objectType: {
    title: 'Тип объекта',
    hint: 'Харвестер не распознал тип в {count} строках. Юнит без типа не попадает в витрину сайта — выберите тип, он проставится всем таким строкам.',
    placeholder: 'Выберите тип',
    skipWarning: 'Без выбора {count} юнитов останутся без типа и в витрину не попадут.',
  },
  blocks: {
    title: 'Корпуса из файла',
    hint: 'Каждому имени из прайса нужен корпус проекта. Юнит без корпуса остаётся и без очереди строительства.',
    fromFile: 'Имя в файле',
    rows: 'Строк',
    target: 'Корпус проекта',
    phase: 'Очередь',
    phasePlaceholder: 'Например, GĐ 2',
    phaseConflict: 'В строках этого корпуса разные очереди: {values}. Выберите одну.',
    optionCreate: 'Создать',
    optionNone: 'Без корпуса',
    willCreate: 'Будет создано корпусов: {count}',
    willSkip: 'Останутся без корпуса: {blocks}',
    created: 'Создано корпусов: {count}',
  },

  draftTitle: 'Импорт: {file}',
  draftsTitle: 'Черновики импорта',
  loadError: 'Не удалось загрузить черновик',
  targetRequired: 'Без проекта строки применять некуда — выберите существующий или создайте новый.',
  bind: 'Привязать',
  bindError: 'Не удалось привязать проект',
  createProject: 'Создать проект',
  saved: 'Все правки сохранены',
  saving: 'Сохранение…',
  saveError: 'Правка не сохранена',
  saveRowError: 'Не удалось сохранить строку',
  codeRequired: 'Код юнита обязателен',
  autosave: 'автосохранение включено',
  chips: {
    all: 'Все',
    new: 'Новые',
    update: 'Обновления',
    unchanged: 'Без изменений',
  },
  diff: {
    new: 'Новый',
    update: 'Обновление',
    unchanged: 'Без изменений',
  },
  columns: {
    diff: 'Метка',
    rowState: 'Состояние',
    file: 'Файл',
    project: 'Проект',
    author: 'Автор',
    created: 'Создан',
    progress: 'Прогресс',
    status: 'Статус',
  },
  rowApplied: 'Применена',
  selectedRows: 'Выбрано: {count}',
  noRowsFilter: 'Под фильтр не попала ни одна строка',
  // Плюрализация: русские формы включены в i18n (pluralRules), иначе PM видит «1 юнитов».
  missingUnits:
    '{count} юнит каталога отсутствует в загруженном файле — вероятно, продан застройщиком. | {count} юнита каталога отсутствуют в загруженном файле — вероятно, проданы застройщиком. | {count} юнитов каталога отсутствуют в загруженном файле — вероятно, проданы застройщиком.',
  showList: 'Показать список',
  hideList: 'Скрыть список',
  markSold: 'Пометить проданными',
  confirmMarkSold:
    'Пометить {count} юнит проданным? Действие изменит каталог сразу. | Пометить {count} юнита проданными? Действие изменит каталог сразу. | Пометить {count} юнитов проданными? Действие изменит каталог сразу.',
  markedSold: 'Помечено проданными: {count}',
  markSoldError: 'Не удалось пометить юниты проданными',
  applyAll: 'Применить всё ({count})',
  applySelected: 'Применить выбранные ({count})',
  applied: 'Применено: создано {created}, обновлено {updated}',
  applyError: 'Не удалось применить строки',
  discard: 'Выбросить черновик',
  confirmDiscard: 'Выбросить черновик? Строки и правки будут потеряны, каталог не изменится.',
  discarded: 'Черновик выброшен',
  discardError: 'Не удалось выбросить черновик',
  continue: 'Продолжить',
  openDraft: 'Открыть',
  noProject: 'Не привязан',
  rowsProgress: '{applied} / {total} строк',
  draftStatus: {
    UNIT_IMPORT_DRAFT_STATUS_IN_PROGRESS: 'В работе',
    UNIT_IMPORT_DRAFT_STATUS_APPLIED: 'Применён',
    UNIT_IMPORT_DRAFT_STATUS_DISCARDED: 'Выброшен',
    UNIT_IMPORT_DRAFT_STATUS_INVALID: '—',
  },
  draftsEmpty: 'Черновиков импорта нет',
  draftsEmptyHint: 'Загрузите прайс застройщика — строки попадут в черновик, а не сразу в каталог.',
  draftsLoadError: 'Не удалось загрузить черновики',
  draftsNote:
    'Черновик хранит правки построчно и не влияет на каталог до применения. Применять можно частями — применённые строки помечаются и остаются в журнале.',
  drafts: 'Черновики импорта',
}

const enImport = {
  title: 'Developer price list import',
  steps: {
    upload: 'Upload file',
    preview: 'Preview and edits',
    apply: 'Apply',
  },
  dropzone: 'Drop the price list here or click to choose',
  dropzoneHint: 'XLSX or CSV, up to {size} MB. All sheets are parsed, including hidden ones.',
  noDriveLinks:
    'Google Drive links are not supported — open the file and download it as Microsoft Excel (.xlsx).',
  chooseAnother: 'Choose another file',
  tooLarge: 'File is larger than {size} MB',
  badFormat: 'Supported formats: xlsx, xlsm, csv, tsv, txt',
  parseAction: 'Upload and parse',
  parsing: 'Parsing the file…',
  parsingHint: 'A few hundred rows take up to a minute — you can keep the page open.',
  parseFailed: 'Failed to parse the file',
  noRows: 'No unit-like rows found — try another sheet',
  noRowsWithCode: 'No row has a unit code — nothing to import',
  rowsParsed: 'Rows: {count}',
  facts: {
    sheet: 'Sheet',
    skippedEmpty: 'Empty rows',
    skippedNoise: 'Not unit-like',
    unmapped: 'Unmapped columns',
  },
  unmappedHint: 'Unmapped columns: {columns}. Their values will not reach the catalogue.',
  notes: {
    priceUnitsAssumed:
      'The price column has no units: values below 1000 were read as tỷ (billion ₫).',
    objectTypeColumnMissing:
      'No object type column found in the file: without a type, units never reach the public listing — set it below.',
    objectTypeUnrecognized:
      'Object type not recognised in {rows} of {total} rows: without a type a unit never reaches the public listing.',
    sheetNotFound: 'Sheet “{sheet}” is not in the file — the richest one was parsed instead.',
    unitsTableNotFound: 'No unit table found: no sheet has recognisable headers.',
    headerRowNotFound: 'No header row found on sheet “{sheet}”.',
    sheetHidden: 'Sheet “{sheet}” is hidden in the file — the catalogue was taken from it.',
    areaAmbiguous:
      'Area from column “{header}” was treated as tim tường (built-up): the header does not say which area it is.',
    rowsNotRecognized: 'No unit rows recognised — check the selected sheet.',
  },
  sheet: 'Sheet',
  sheetOption: '{name} · rows: {rows}',
  sheetHidden: '{name} (hidden) · rows: {rows}',
  reparse: 'Re-parse',
  targetProject: 'Target project',
  targetExisting: 'Add to an existing one',
  targetNew: 'Create a new project — saved as a draft (not published)',
  targetNewHint:
    'The import draft is created without a project: link it on the next step once the project exists.',
  searchProject: 'Start typing the project name',
  createDraft: 'Create draft',
  createDraftError: 'Failed to create the import draft',
  skippedNoCode: 'Rows skipped without a unit code: {count}',
  objectType: {
    title: 'Object type',
    hint: 'The harvester could not recognise the type in {count} rows. A unit without a type never reaches the public showcase — pick one and it fills every such row.',
    placeholder: 'Pick a type',
    skipWarning: 'Without a choice {count} units stay typeless and will not reach the showcase.',
  },
  blocks: {
    title: 'Blocks from the file',
    hint: 'Every name in the price list needs a project block. A unit without a block has no construction phase either.',
    fromFile: 'Name in file',
    rows: 'Rows',
    target: 'Project block',
    phase: 'Phase',
    phasePlaceholder: 'For example, GĐ 2',
    phaseConflict: 'Rows of this block carry different phases: {values}. Pick one.',
    optionCreate: 'Create',
    optionNone: 'No block',
    willCreate: 'Blocks to create: {count}',
    willSkip: 'Will stay without a block: {blocks}',
    created: 'Blocks created: {count}',
  },

  draftTitle: 'Import: {file}',
  draftsTitle: 'Import drafts',
  loadError: 'Failed to load the draft',
  targetRequired: 'Rows cannot be applied without a project — pick an existing one or create it.',
  bind: 'Link',
  bindError: 'Failed to link the project',
  createProject: 'Create project',
  saved: 'All changes saved',
  saving: 'Saving…',
  saveError: 'Change not saved',
  saveRowError: 'Failed to save the row',
  codeRequired: 'Unit code is required',
  autosave: 'autosave is on',
  chips: {
    all: 'All',
    new: 'New',
    update: 'Updates',
    unchanged: 'Unchanged',
  },
  diff: {
    new: 'New',
    update: 'Update',
    unchanged: 'Unchanged',
  },
  columns: {
    diff: 'Label',
    rowState: 'State',
    file: 'File',
    project: 'Project',
    author: 'Author',
    created: 'Created',
    progress: 'Progress',
    status: 'Status',
  },
  rowApplied: 'Applied',
  selectedRows: 'Selected: {count}',
  noRowsFilter: 'No rows match the filter',
  missingUnits:
    '{count} catalogue unit is missing from the file — likely sold by the developer. | {count} catalogue units are missing from the file — likely sold by the developer.',
  showList: 'Show list',
  hideList: 'Hide list',
  markSold: 'Mark as sold',
  confirmMarkSold: 'Mark {count} units as sold? This changes the catalogue immediately.',
  markedSold: 'Marked as sold: {count}',
  markSoldError: 'Failed to mark units as sold',
  applyAll: 'Apply all ({count})',
  applySelected: 'Apply selected ({count})',
  applied: 'Applied: {created} created, {updated} updated',
  applyError: 'Failed to apply the rows',
  discard: 'Discard draft',
  confirmDiscard: 'Discard the draft? Rows and edits are lost, the catalogue stays unchanged.',
  discarded: 'Draft discarded',
  discardError: 'Failed to discard the draft',
  continue: 'Continue',
  openDraft: 'Open',
  noProject: 'Not linked',
  rowsProgress: '{applied} / {total} rows',
  draftStatus: {
    UNIT_IMPORT_DRAFT_STATUS_IN_PROGRESS: 'In progress',
    UNIT_IMPORT_DRAFT_STATUS_APPLIED: 'Applied',
    UNIT_IMPORT_DRAFT_STATUS_DISCARDED: 'Discarded',
    UNIT_IMPORT_DRAFT_STATUS_INVALID: '—',
  },
  draftsEmpty: 'No import drafts',
  draftsEmptyHint: 'Upload a developer price list — rows land in a draft, not in the catalogue.',
  draftsLoadError: 'Failed to load drafts',
  draftsNote:
    'A draft keeps edits row by row and does not affect the catalogue until applied. Apply in parts — applied rows stay marked in the log.',
  drafts: 'Import drafts',
}

const vnImport = {
  title: 'Nhập bảng giá của chủ đầu tư',
  steps: {
    upload: 'Tải tệp',
    preview: 'Xem trước và chỉnh sửa',
    apply: 'Áp dụng',
  },
  dropzone: 'Kéo tệp bảng giá vào đây hoặc bấm để chọn',
  dropzoneHint: 'XLSX hoặc CSV, tối đa {size} MB. Đọc tất cả các sheet, kể cả sheet ẩn.',
  noDriveLinks:
    'Không hỗ trợ liên kết Google Drive — hãy mở bảng tính và tải về dạng Microsoft Excel (.xlsx).',
  chooseAnother: 'Chọn tệp khác',
  tooLarge: 'Tệp lớn hơn {size} MB',
  badFormat: 'Định dạng hỗ trợ: xlsx, xlsm, csv, tsv, txt',
  parseAction: 'Tải lên và phân tích',
  parsing: 'Đang phân tích tệp…',
  parsingHint: 'Vài trăm dòng mất tới một phút — có thể giữ nguyên trang.',
  parseFailed: 'Không phân tích được tệp',
  noRows: 'Không tìm thấy dòng nào giống căn hộ — hãy thử sheet khác',
  noRowsWithCode: 'Không dòng nào có mã căn — không có gì để nhập',
  rowsParsed: 'Số dòng: {count}',
  facts: {
    sheet: 'Sheet',
    skippedEmpty: 'Dòng trống',
    skippedNoise: 'Không giống căn hộ',
    unmapped: 'Cột chưa nhận diện',
  },
  unmappedHint: 'Cột chưa nhận diện: {columns}. Giá trị của chúng sẽ không vào danh mục.',
  notes: {
    priceUnitsAssumed: 'Cột giá không ghi đơn vị: các giá trị nhỏ hơn 1000 được hiểu là tỷ (₫).',
    objectTypeColumnMissing:
      'Không tìm thấy cột loại hình trong tệp: thiếu loại hình, căn hộ sẽ không lên trang giới thiệu — hãy chọn bên dưới.',
    objectTypeUnrecognized:
      'Không nhận diện được loại hình ở {rows} trên {total} dòng: thiếu loại hình, căn sẽ không lên trang giới thiệu.',
    sheetNotFound: 'Không có sheet «{sheet}» trong tệp — đã phân tích sheet đầy đủ nhất.',
    unitsTableNotFound: 'Không tìm thấy bảng căn: không sheet nào có tiêu đề nhận diện được.',
    headerRowNotFound: 'Không tìm thấy dòng tiêu đề trên sheet «{sheet}».',
    sheetHidden: 'Sheet «{sheet}» bị ẩn trong tệp — danh mục được lấy từ đó.',
    areaAmbiguous:
      'Diện tích từ cột «{header}» được xếp vào tim tường (built-up): tiêu đề không ghi rõ loại diện tích.',
    rowsNotRecognized: 'Không nhận diện được dòng căn nào — kiểm tra sheet đã chọn.',
  },
  sheet: 'Sheet',
  sheetOption: '{name} · dòng: {rows}',
  sheetHidden: '{name} (ẩn) · dòng: {rows}',
  reparse: 'Đọc lại',
  targetProject: 'Dự án đích',
  targetExisting: 'Thêm vào dự án hiện có',
  targetNew: 'Tạo dự án mới — lưu ở dạng nháp (không hiển thị)',
  targetNewHint: 'Bản nháp nhập sẽ chưa gắn dự án: hãy gắn ở bước sau khi đã tạo dự án.',
  searchProject: 'Nhập tên dự án',
  createDraft: 'Tạo bản nháp',
  createDraftError: 'Không tạo được bản nháp nhập',
  skippedNoCode: 'Số dòng bị bỏ qua vì thiếu mã căn: {count}',
  objectType: {
    title: 'Loại hình',
    hint: 'Không nhận diện được loại hình ở {count} dòng. Căn không có loại hình sẽ không lên trang bán hàng — hãy chọn một loại cho tất cả.',
    placeholder: 'Chọn loại hình',
    skipWarning: 'Nếu không chọn, {count} căn sẽ không có loại hình và không lên trang bán hàng.',
  },
  blocks: {
    title: 'Tòa trong tệp',
    hint: 'Mỗi tên trong bảng giá cần một tòa của dự án. Căn hộ không có tòa cũng không có giai đoạn.',
    fromFile: 'Tên trong tệp',
    rows: 'Số dòng',
    target: 'Tòa của dự án',
    phase: 'Giai đoạn',
    phasePlaceholder: 'Ví dụ: GĐ 2',
    phaseConflict: 'Các dòng của tòa này có giai đoạn khác nhau: {values}. Hãy chọn một.',
    optionCreate: 'Tạo mới',
    optionNone: 'Không gán tòa',
    willCreate: 'Số tòa sẽ tạo: {count}',
    willSkip: 'Sẽ không có tòa: {blocks}',
    created: 'Đã tạo tòa: {count}',
  },

  draftTitle: 'Nhập: {file}',
  draftsTitle: 'Bản nháp nhập',
  loadError: 'Không tải được bản nháp',
  targetRequired: 'Chưa có dự án thì không áp dụng được — hãy chọn hoặc tạo dự án.',
  bind: 'Gắn',
  bindError: 'Không gắn được dự án',
  createProject: 'Tạo dự án',
  saved: 'Đã lưu mọi thay đổi',
  saving: 'Đang lưu…',
  saveError: 'Chưa lưu được thay đổi',
  saveRowError: 'Không lưu được dòng',
  codeRequired: 'Bắt buộc có mã căn',
  autosave: 'tự động lưu đang bật',
  chips: {
    all: 'Tất cả',
    new: 'Mới',
    update: 'Cập nhật',
    unchanged: 'Không đổi',
  },
  diff: {
    new: 'Mới',
    update: 'Cập nhật',
    unchanged: 'Không đổi',
  },
  columns: {
    diff: 'Nhãn',
    rowState: 'Trạng thái dòng',
    file: 'Tệp',
    project: 'Dự án',
    author: 'Người tạo',
    created: 'Ngày tạo',
    progress: 'Tiến độ',
    status: 'Trạng thái',
  },
  rowApplied: 'Đã áp dụng',
  selectedRows: 'Đã chọn: {count}',
  noRowsFilter: 'Không có dòng nào khớp bộ lọc',
  missingUnits: '{count} căn trong danh mục không có trong tệp — có thể đã bán.',
  showList: 'Hiện danh sách',
  hideList: 'Ẩn danh sách',
  markSold: 'Đánh dấu đã bán',
  confirmMarkSold: 'Đánh dấu {count} căn là đã bán? Danh mục sẽ thay đổi ngay.',
  markedSold: 'Đã đánh dấu bán: {count}',
  markSoldError: 'Không đánh dấu được',
  applyAll: 'Áp dụng tất cả ({count})',
  applySelected: 'Áp dụng mục đã chọn ({count})',
  applied: 'Đã áp dụng: tạo mới {created}, cập nhật {updated}',
  applyError: 'Không áp dụng được các dòng',
  discard: 'Bỏ bản nháp',
  confirmDiscard: 'Bỏ bản nháp? Các dòng và chỉnh sửa sẽ mất, danh mục giữ nguyên.',
  discarded: 'Đã bỏ bản nháp',
  discardError: 'Không bỏ được bản nháp',
  continue: 'Tiếp tục',
  openDraft: 'Mở',
  noProject: 'Chưa gắn',
  rowsProgress: '{applied} / {total} dòng',
  draftStatus: {
    UNIT_IMPORT_DRAFT_STATUS_IN_PROGRESS: 'Đang xử lý',
    UNIT_IMPORT_DRAFT_STATUS_APPLIED: 'Đã áp dụng',
    UNIT_IMPORT_DRAFT_STATUS_DISCARDED: 'Đã bỏ',
    UNIT_IMPORT_DRAFT_STATUS_INVALID: '—',
  },
  draftsEmpty: 'Chưa có bản nháp nhập',
  draftsEmptyHint: 'Tải bảng giá lên — các dòng vào bản nháp, chưa vào danh mục.',
  draftsLoadError: 'Không tải được danh sách bản nháp',
  draftsNote:
    'Bản nháp lưu chỉnh sửa theo từng dòng và không ảnh hưởng danh mục cho tới khi áp dụng. Có thể áp dụng từng phần — dòng đã áp dụng vẫn được ghi nhận.',
  drafts: 'Bản nháp nhập',
}

export const priceImportMessages = {
  ru: { properties: { import: ruImport } },
  en: { properties: { import: enImport } },
  vn: { properties: { import: vnImport } },
}
